import React, { Fragment, useState } from 'react';
import { createRefetchContainer } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { Typography } from '@material-ui/core';

import AutoTable from '../../../../../shared/components/table/AutoTable';
import {
  formatAuditLogDescription,
  formatAuditLogAction
} from '../../../../../shared/utils/helpers';
import { CELL_TYPES } from '../../../../../shared/constants';
import useUpdateEffect from '../../../../../shared/hooks/useUpdateEffect';

const DeliverableActionLogList = props => {
  const {
    relay: { refetch },
    deliverable: { id, history: historyLog }
  } = props;

  const [refetchCounter, setRefetchCounter] = useState(0);

  useUpdateEffect(() => {
    setRefetchCounter(prev => prev + 1);
  }, [props.refetchCounter, props.refetchCounterForTools]);

  if (!historyLog) return <div>Something went wrong!</div>;

  const {
    edges,
    edgeCount,
    totalCount,
    pageInfo: { hasNextPage, endCursor }
  } = historyLog;

  const onChangeHandler = variables => {
    refetch({ id, ...variables });
  };

  const formattedEdges = edges.map(edge => {
    const {
      id,
      timestamp: date,
      actor: { orgStaff, freelancer },
      action,
      changes,
      additionalData
    } = edge.node;
    const fullName = orgStaff ? orgStaff.fullName : freelancer ? freelancer.fullName : '';
    const representativeImageUrl = orgStaff
      ? orgStaff.representativeImageUrl
      : freelancer
      ? freelancer.representativeImageUrl
      : '';
    return {
      node: {
        id,
        date,
        who: { name: fullName, imageUrl: representativeImageUrl },
        action: formatAuditLogAction(action, additionalData),
        changes: formatAuditLogDescription(action, changes, additionalData)
      }
    };
  });

  return (
    <Fragment>
      <Typography variant="h3">Audit Log</Typography>
      <AutoTable
        rowTemplate={[
          { name: 'action', label: 'Action' },
          { name: 'changes', label: 'Changes', width: '50%' },
          { name: 'date', label: 'Date', type: CELL_TYPES.date },
          { name: 'who', label: 'Who', type: CELL_TYPES.avatar }
        ]}
        edges={formattedEdges}
        refetchCounter={refetchCounter}
        onChangeHandler={onChangeHandler}
        paginationProps={{ edgeCount, totalCount, hasNextPage, endCursor }}
      />
    </Fragment>
  );
};

export default createRefetchContainer(
  DeliverableActionLogList,
  {
    deliverable: graphql`
      fragment DeliverableActionLogList_deliverable on DeliverableNode {
        id
        history(first: $first, after: $after) {
          pageInfo {
            hasNextPage
            endCursor
          }
          totalCount
          edgeCount
          edges {
            node {
              id
              timestamp
              actor {
                orgStaff {
                  fullName
                  representativeImageUrl
                }
                freelancer {
                  fullName
                  representativeImageUrl
                }
              }
              action
              changes
              additionalData
            }
          }
        }
      }
    `
  },
  graphql`
    query DeliverableActionLogListRefetchQuery($id: ID!, $first: Int, $after: String) {
      deliverable(id: $id) {
        ...DeliverableActionLogList_deliverable
      }
    }
  `
);
